import React, { useEffect, useRef, useState } from 'react';
import { PaymentScheduleDto } from '../../../services/dtos/payment-schedule.dto';
import PaymentScheduleUi from '../../../components/user-interfaces/contract/payment-schedule/payment-schedule.ui';
import { useParams } from 'react-router-dom';
import { showAxiosMessageError } from '../../../services/error-message.service';
import { getLastBill } from '../../../services/bills.service';
import { useSnackbars } from '../../../hooks/snackbar.hook';

/**
 * Composant de la page d'un contrat
 */
export default function PaymentSchedulePage() {
    //Navigate
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);
    // Données de l'échéancier
    const [paymentSchedule, setPaymentSchedule] = useState<Array<PaymentScheduleDto>>();
    // Id du contrat
    const { id } = useParams();
    const showMessage = useSnackbars();

    /**
     * Récupération du contrat à afficher
     */
    useEffect(() => {
        //Ordre pour ne pas recharger le use effect
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;

        getLastBill(id)
            .then(result => {
                if (result?.bills?.length === 1) {
                    if (result.bills[0].facture?.echeances?.length && result.bills[0].facture?.echeances?.length > 0) {
                        setPaymentSchedule(result.bills[0].facture?.echeances);
                    }
                }
            })
            .catch(error => {
                console.error('Erreur lors de la récupération du contrat');
                showAxiosMessageError(error, showMessage);
            });
        //https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        //Affichage de tabs
        //Gestion des contenus des différents tabs
        <PaymentScheduleUi paymentSchedule={paymentSchedule} id={id} />
    );
}
